import BaseModel from '../core/BaseModel'
export default class AreaModel extends BaseModel {
    constructor() {
        super({
            tableName: 'area', label: " Khu Vực Làm Việc", display_key: 'name',name: "area",
        }, {
            stt: { 
              name: "stt", 
              label: "STT",
              class: 'center width_150 common',
              computed: (data, index) => {
                data.stt = index + 1;
              }
            },
            id: { 
              name: 'id', 
              type: "Uuid", 
              label: 'ID', 
              primaryKey: true,  
              display: false
            },
            name: {
                name: "name",
                type: "String",
                label: "Tên khu vực",
                filter: { type: "input", match: "contains" },
            },
            factory: {
              name: "factory",
              label: "Nhà máy/ trang trại",
              type: "MultiSelect",
              filter: {
                type: "SelectScroll",
                optionLabel: "name",
                optionKey: "id",
                match: "equals",
              },
            },
            active: {
                name: "active",
                label: "Hiển thị",
                type: "Boolean",
                class: "center"
            },
            updated_by: {
                refs:"updated_by",
                type: "String",
                label: "Người cập nhật"
            },
            updated_at : {
              name: 'updated_at',
              type: "Datetime",
              label: 'Cập nhât cuối',
            },
        })
    }

}